import { render, staticRenderFns } from "./ServiceChargesStandard.vue?vue&type=template&id=44b59719&scoped=true&"
import script from "./ServiceChargesStandard.vue?vue&type=script&lang=js&"
export * from "./ServiceChargesStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b59719",
  null
  
)

export default component.exports